import { Facility } from "./Facility";

export class Location{

    constructor(
        public id:string,
        public name:string,
        public country:string,
        public address:string,
        public postalCode:string,
        public city:string,
        public facilities: Facility[],
        public created: Date,
    ){}
}